import { render, staticRenderFns } from "./NormalTable.vue?vue&type=template&id=179da745&scoped=true"
import script from "./NormalTable.vue?vue&type=script&lang=js"
export * from "./NormalTable.vue?vue&type=script&lang=js"
import style0 from "./NormalTable.vue?vue&type=style&index=0&id=179da745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179da745",
  null
  
)

export default component.exports